var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{staticStyle:{"min-height":"90vh"},attrs:{"width":"90%"},scopedSlots:_vm._u([{key:"default",fn:function({ isActive }){return [_c('v-card',[_c('v-card-title',[_vm._v(" Bulk Upload KML ")]),_c('v-card-text',[(_vm.step == 1)?_c('div',{staticClass:"upload d-flex flex-column"},[_c('label',{attrs:{"for":"kml"}},[_vm._v("File KML")]),_c('div',{staticClass:"upload-file-wrapper"},[_c('label',{staticClass:"kml-file",attrs:{"for":"kmlFile"}},[_c('div',{staticClass:"wrapper"},[_c('v-icon',[_vm._v("mdi-vector-polygon")])],1)]),_c('p',{staticClass:"kml-label"},[(!_vm.files)?_c('span',{staticClass:"ml-2"},[_vm._v("Upload file KML yang berisi banyak lahan")]):_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.files_name))])]),_c('input',{attrs:{"id":"kmlFile","type":"file"},on:{"change":function($event){return _vm.handleFileChange($event)}}})]),_c('div',{staticClass:"d-flex flex-row justify-content-center"},[_c('v-btn',{attrs:{"variant":"success"},on:{"click":_vm.onUplaod}},[(!_vm.loading)?_c('v-icon',[_vm._v("mdi-cloud-upload-outline")]):_c('v-progress-circular',{attrs:{"size":20,"color":"success","indeterminate":""}}),_c('span',[_vm._v("Upload")])],1)],1)]):_vm._e(),(_vm.step == 2)?_c('div',{staticClass:"d-flex flex-column result"},[_c('ValidationObserver',{ref:"mainForm",scopedSlots:_vm._u([{key:"default",fn:function({ handleSubmit }){return [(_vm.ready)?_c('form',{attrs:{"autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.onBulkUpload)}}},[_c('div',{staticClass:"mt-4"},[_vm._l((_vm.questions),function(q,i){return _c('p',{staticClass:"mb-0 text-09-em"},[_vm._v(" "+_vm._s(`Pertanyaan ${i + 1} : ${q.question}`)+" ")])}),_c('div',{staticClass:"table-wrapper",staticStyle:{"width":"100%","overflow-x":"auto"}},[_c('table',{staticClass:"geko-table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_c('th',[_vm._v("No Lahan")]),_c('th',{staticStyle:{"min-width":"200px"}},[_vm._v(" Kelengkapan Data & Status ")]),_c('th',[_vm._v("Altitude")]),_c('th',[_vm._v("Luas Polygon")]),_c('th',{staticStyle:{"min-width":"200px"}},[_vm._v("Jenis Tanah")]),_vm._l((_vm.questions),function(q,i){return _c('th',{key:`head-${i}`,staticStyle:{"min-width":"150px"}},[_vm._v(" "+_vm._s(`Pertanyaan ${i + 1}`)+" ")])})],2)]),_c('tbody',_vm._l((_vm.data),function(item,i){return _c('tr',{key:`key-${i}`},[_c('td',[_vm._v(_vm._s(i + 1))]),_c('td',{staticClass:"font-weight-bold"},[_c('a',{staticClass:"mb-0 text-link",attrs:{"target":"_blank","href":`/#/lahan-v2?view=detail&id=${item.id}`}},[_vm._v(_vm._s(item.lahan_no))])]),_c('td',[_c('div',{staticClass:"d-flex flex-row justify-content-center"},[_c('span',{staticClass:"badge text-08-em",class:{
                                'bg-success': item.fc_complete_data == 1,
                                'bg-info':
                                  item.fc_complete_data == 0 ||
                                  item.fc_complete_data == null,
                              }},[_vm._v(" "+_vm._s(item.fc_complete_data ? "Lengkap" : "Belum Diverifikasi FC")+" ")])]),_c('div',{staticClass:"d-flex flex-row justify-content-center mt-2"},[_c('span',{staticClass:"badge text-08-em",class:{
                                'bg-warning':
                                  item.approve == 0 &&
                                  item.updated_gis.toLowerCase() == 'belum',
                                'bg-info':
                                  item.approve == 0 &&
                                  item.updated_gis.toLowerCase() == 'sudah',
                                'bg-primary': item.approve == 1,
                                'bg-success': item.approve == 2,
                                'bg-danger': item.approve == 3,
                              }},[(
                                  item.approve == 0 &&
                                  item.updated_gis.toLowerCase() == 'belum'
                                )?_c('span',[_vm._v("Belum Diverifikasi")]):_vm._e(),(
                                  item.approve == 0 &&
                                  item.updated_gis.toLowerCase() == 'sudah'
                                )?_c('span',[_vm._v("Diverifikasi GIS")]):(item.approve == 1)?_c('span',[_vm._v("Diverifikasi FC")]):(item.approve == 2)?_c('span',[_vm._v("Terverifikasi")]):(item.approve == 3)?_c('span',[_vm._v("Force Majeure")]):_vm._e()])])]),_c('td',[_c('geko-input',{attrs:{"disabled":item.fc_complete_data != 1,"item":{
                              label: 'Altitude (mdpl)',
                              type: 'text',
                              validation:
                                item.fc_complete_data != 1
                                  ? []
                                  : ['required'],
                              hide_label: true,
                            }},model:{value:(item.elevation),callback:function ($$v) {_vm.$set(item, "elevation", $$v)},expression:"item.elevation"}})],1),_c('td',[_c('geko-input',{attrs:{"disabled":item.fc_complete_data != 1,"item":{
                              label: 'Luas Polygon ',
                              validation:
                                item.fc_complete_data != 1
                                  ? []
                                  : ['required', 'double:2'],
                              type: 'text',
                              hide_label: true,
                            }},model:{value:(item.gis_polygon_area),callback:function ($$v) {_vm.$set(item, "gis_polygon_area", $$v)},expression:"item.gis_polygon_area"}})],1),_c('td',[_c('geko-input',{attrs:{"disabled":item.fc_complete_data != 1,"item":{
                              label: 'Luas Polygon ',
                              type: 'select',
                              validation:
                                item.fc_complete_data != 1
                                  ? []
                                  : ['required'],
                              option: {
                                default_options: [
                                  {
                                    label: 'Aluvial',
                                    code: 'Aluvial',
                                  },
                                  {
                                    label: 'Alvisol',
                                    code: 'Alvisol',
                                  },
                                  {
                                    label: 'Andosol',
                                    code: 'Andosol',
                                  },
                                  {
                                    label: 'Andosol Distrik',
                                    code: 'Andosol Distrik',
                                  },
                                  {
                                    label: 'Andosol Eutrik',
                                    code: 'Andosol Eutrik',
                                  },
                                  {
                                    label: 'Andosol Litik',
                                    code: 'Andosol Litik',
                                  },
                                  {
                                    label: 'Andosol Melanik',
                                    code: 'Andosol Melanik',
                                  },
                                  {
                                    label: 'Arenosol',
                                    code: 'Arenosol',
                                  },
                                  {
                                    label: 'Entisol',
                                    code: 'Entisol',
                                  },
                                  {
                                    label: 'Gleisol',
                                    code: 'Gleisol',
                                  },
                                  {
                                    label: 'Grumosol',
                                    code: 'Grumosol',
                                  },
                                  {
                                    label: 'Histosol',
                                    code: 'Histosol',
                                  },
                                  {
                                    label: 'Inseptisol',
                                    code: 'Inseptisol',
                                  },
                                  {
                                    label: 'Kambisol',
                                    code: 'Kambisol',
                                  },
                                  {
                                    label: 'Latosol',
                                    code: 'Latosol',
                                  },
                                  {
                                    label: 'Latosol Haplik',
                                    code: 'Latosol Haplik',
                                  },
                                  {
                                    label: 'Latosol Kromik',
                                    code: 'Latosol Kromik',
                                  },
                                  {
                                    label: 'Litosol',
                                    code: 'Litosol',
                                  },
                                  {
                                    label: 'Mediteran',
                                    code: 'Mediteran',
                                  },
                                  {
                                    label: 'Molisol',
                                    code: 'Molisol',
                                  },
                                  {
                                    label: 'Nitosol',
                                    code: 'Nitosol',
                                  },
                                  {
                                    label: 'Organosol',
                                    code: 'Organosol',
                                  },
                                  {
                                    label: 'Podsolik',
                                    code: 'Podsolik',
                                  },
                                  {
                                    label: 'Podsolik Haplik',
                                    code: 'Podsolik Haplik',
                                  },
                                ],
                                list_pointer: {
                                  label: 'label',
                                  code: 'code',
                                  display: ['label'],
                                },
                              },
                              hide_label: true,
                            }},model:{value:(item.soil_type),callback:function ($$v) {_vm.$set(item, "soil_type", $$v)},expression:"item.soil_type"}})],1),_vm._l((_vm.questions),function(q,i){return _c('td',{key:`qt-${i}`},[_c('geko-input',{attrs:{"disabled":item.fc_complete_data != 1,"item":{
                              hide_label: true,
                              type: 'select-radio',
                              validation:
                                item.fc_complete_data != 1
                                  ? []
                                  : ['required'],
                              option: {
                                default_options: [
                                  {
                                    label: 'Ya',
                                    code: '1',
                                  },
                                  {
                                    label: 'Tidak',
                                    code: '0',
                                  },
                                ],
                                list_pointer: {
                                  label: 'name',
                                  code: 'code',
                                  display: ['name'],
                                },
                              },
                            }},model:{value:(item[`question${i + 1}`]),callback:function ($$v) {_vm.$set(item, `question${i + 1}`, $$v)},expression:"item[`question${i + 1}`]"}})],1)})],2)}),0)])]),_c('div',{staticClass:"d-flex flex-row justify-content-center mt-3"},[_c('v-btn',{attrs:{"variant":"success","type":"submit"}},[(!_vm.loading)?_c('v-icon',[_vm._v(" mdi-shape-polygon-plus ")]):_c('v-progress-circular',{attrs:{"size":20,"color":"success","indeterminate":""}}),_c('span',{staticClass:"ml-1"},[_vm._v("Verifikasi Data")])],1)],1)],2)]):_vm._e()]}}],null,true)})],1):_vm._e()])],1)]}}]),model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}})
}
var staticRenderFns = []

export { render, staticRenderFns }